import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GridService } from '../shared/grid/grid.service';
import { AnalyticalMethod } from '../models/analyticalMethod.model';

@Injectable({
    providedIn: 'root'
})
export class AnalyticalMethodService extends GridService<AnalyticalMethod> {

    constructor(http: HttpClient) {
        super('AnalyticalMethod', http);
    }
}